<template>
  <path
    d="M17 1.01024L7.00001 1.00024C5.90001 1.00024 5.01001 1.90024 5.01001 3.00024V21.0002C5.01001 22.1002 5.90001 23.0002 7.00001 23.0002H17C18.1 23.0002 19 22.1002 19 21.0002V3.00024C19 1.90024 18.1 1.01024 17 1.01024ZM17 19.0002H7.00001V5.00024H17V19.0002Z"
  />
</template>
